import { Row, Col, Alert } from 'react-bootstrap';
import CartSection from './CartSection';

const CartClassicLayout = ({ cart, labels, continuity, isPR }) => {
  let achDisclaimerCopyComponent;
  if (continuity !== 'Continuity' && !isPR) {
    achDisclaimerCopyComponent = (
      <Row>
        <Col sm={{ span: 8 }} md={{ span: 6 }}>
          <h6>{labels.achDisclaimer}</h6>
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row className="mt-3">
        <Col>
          <Alert>
            <h3>{labels.cart}</h3>
          </Alert>
        </Col>
      </Row>

      <Row>
        <Col>
          <CartSection title={labels.cartPlanFees} items={cart.feesAndCredits} total={cart.totalFeesAndCredits} />
          <CartSection title={labels.cartOtherFees} items={cart.otherFeesAndCredits} total={cart.totalOtherFeesAndCredits} />
          <CartSection title={labels.cartOneTimeFees} items={cart.oneTimeFeesAndCredits} total={cart.totalOneTimeFeesAndCredits} />
          <br />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col sm={{ span: 6 }} md={{ span: 4 }}>
          <h4 className="total">{labels.cartTotal} ${Number(cart.total).toFixed(2)}</h4>
        </Col>
      </Row>

      {achDisclaimerCopyComponent}
    </>
  );
};

export default CartClassicLayout;
